<template>
  <div
    class="voice-room-rank"
    :class="{ 'bg-black': label === '3' || label === '4' }"
  >
    <el-tabs v-model="label" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('components_voiceroom_component_rank_index_1892')" name="1">
        <charm-rank ref="charmRank" :roomUid="roomUid"></charm-rank>
      </el-tab-pane>
      <el-tab-pane :label="$t('components_voiceroom_component_rank_index_1893')" name="2">
        <contribution-rank
          ref="contributionRank"
          :roomUid="roomUid"
        ></contribution-rank>
      </el-tab-pane>
      <el-tab-pane :label="$t('components_voiceroom_component_rank_index_1894')" name="3">
        <luck-rank ref="luckRank" :roomUid="roomUid"></luck-rank>
      </el-tab-pane>
      <el-tab-pane :label="$t('components_voiceroom_component_rank_index_1895')" name="4">
        <online-members ref="onlineMembers" :roomUid="roomUid"></online-members>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import charmRank from './charm-rank.vue';
import contributionRank from './contribution-rank.vue';
import luckRank from './luck-rank.vue';
import onlineMembers from '../online-members.vue';
export default {
  name: 'Rank',
  components: {
    charmRank,
    contributionRank,
    luckRank,
    onlineMembers
  },
  props: {
    roomUid: {
      type: String
    }
  },
  data() {
    return {
      label: '1',
      interval: null
    };
  },
  computed: {},
  methods: {
    handleTabClick() {
      if (this.label == '1') {
        this.$refs.charmRank.getList();
      } else if (this.label == '2') {
        this.$refs.contributionRank.getList();
      } else if (this.label == '3') {
        this.$refs.luckRank.initGetList();
      } else {
        this.$refs.onlineMembers.getList();
      }
    },
    setTimeRequest() {
      this.interval = setInterval(() => {
        if (this.label == '1') {
          this.$refs.charmRank.getList();
        } else if (this.label == '2') {
          this.$refs.contributionRank.getList();
        } else if (this.label == '3') {
          this.$refs.luckRank.initGetList();
        } else {
          this.$refs.onlineMembers.getList();
        }
      }, 15000);
    }
  },
  mounted() {
    this.setTimeRequest();
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>
<style lang="scss" scoped>
.voice-room-rank {
  background-color: #423e44;
  height: 100%;
  &.bg-black {
    background-color: #1a1828;
  }
  /deep/ .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      height: 1px;
      flex: auto;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/ .el-tabs__header {
    .el-tabs__item {
      height: 50px;
      line-height: 50px;
    }
    &.is-top {
      margin-bottom: 0;
    }
  }
}
</style>
